import { View, Text, Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import useCurrentUser from "../hooks/useCurrentUser/useCurrentUser";
import Button from "./Button";

const ImpersonationOverlay = () => {
  const insets = useSafeAreaInsets();
  const { impersonatedUser, clearAssumedUser } = useCurrentUser();

  if (!impersonatedUser) return null;

  return (
    <View
      className="px-8 bg-red pt-2 w-full"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        paddingBottom: insets.bottom,
        ...(Platform.OS === "web"
          ? { position: "absolute", top: 0, left: 0, zIndex: 10000, paddingTop: 14, paddingBottom: 14 }
          : {}),
      }}
    >
      <View>
        <Text>You are impersonating</Text>
        <Text>
          {impersonatedUser.firstName} {impersonatedUser.lastName} ({impersonatedUser.memberNumber})
        </Text>
      </View>
      <Button size="small" mode="secondary" onPress={() => clearAssumedUser()}>
        I'm Done
      </Button>
    </View>
  );
};

export default ImpersonationOverlay;
